import { GalleryItem } from '../../../../models';

export const galleryMap = (galleryItems?: GalleryItem[]) => {
  return galleryItems?.map((galleryItem) => {
    const { image, audio, video, pdf, title } = galleryItem;

    const { id, rightholder } = { ...image };

    const imageMapped = id && { image: { id, ...(rightholder && { rightholder }) } };

    switch (true) {
      case Boolean(audio):
        return { audio: { id: audio?.id, useDefaultThumb: false }, ...imageMapped, title };
      case Boolean(video):
        return { video: { id: video?.id, useDefaultThumb: true }, ...imageMapped, title };
      case Boolean(pdf):
        return { pdf: { id: pdf?.id, useDefaultThumb: false }, ...imageMapped, title };
      case Boolean(image):
        return { ...imageMapped, ...(title && { title }) };
      default:
        return null;
    }
  });
};
